import React from 'react';
import { FeedList } from '../../react/components/feed/list';

const Feed = () => {
  return <FeedList />;
};

export default Feed;
